import { useCallback } from "react";

import { apiClient, StatusEnum } from "@/features/shared";
import { CustomAutocomplete } from "@/features/ui";

export const SupplierCategorySelect = (props) => {
  const fetchSupplierCategories = useCallback(async () => {
    const {
      data: { data },
    } = await apiClient.get("supplier-categories", {
      params: {
        status: StatusEnum.ACTIVE,
      },
    });
    return data;
  }, []);

  return (
    <CustomAutocomplete
      fetchOptions={fetchSupplierCategories}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, selectedOption) =>
        option.id === selectedOption.id
      }
      {...props}
    />
  );
};
